import { render, staticRenderFns } from "./ExportButton.vue?vue&type=template&id=60022f6a&scoped=true"
import script from "./ExportButton.vue?vue&type=script&lang=js"
export * from "./ExportButton.vue?vue&type=script&lang=js"
import style0 from "./ExportButton.vue?vue&type=style&index=0&id=60022f6a&prod&scoped=true&lang=scss"
import style1 from "./ExportButton.vue?vue&type=style&index=1&id=60022f6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60022f6a",
  null
  
)

export default component.exports